import {Button} from 'antd';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const RelatedProducts = ({products, currentProduct}) => {

  // filter related products
  const related = products
    ?.filter(
      item =>
        item.jewelryType === currentProduct.jewelryType &&
        item.id !== currentProduct.id,
    )
    .slice(0, 8);

  // slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {slidesToShow: 3, slidesToScroll: 2},
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className={'w-full h-auto lg:mb-10 mb-5'}>

      <h1 className={'lg:text-2xl font-semibold mt-5 text-primary-900 text-center font-serif-custom'}>
        You May Like These...
      </h1>

      <div className={'max-w-5xl w-full mx-auto lg:my-5'}>

        <Slider {...settings}>

          {related?.map(item => {

            // get default size price
            const defaultSizePrice =
              item.size && item.size.length > 0
                ? item.size[0].price
                : item.price;

            return (
              <div key={item.id} className={'p-2'}>

                <div className={'shadow-md p-3 rounded-lg flex flex-col h-full justify-between'}>

                  <Link to={`/product/${item.id}`} state={{product: item}}>

                    {/* image */}
                    <div className={'lg:w-46 lg:h-48 h-40 flex items-center justify-center'}>
                      <img
                        src={
                          Array.isArray(item.imageUrl)
                            ? item.imageUrl[0]
                            : item.imageUrl
                        }
                        alt={item.productName}
                        className={
                          'w-full h-full object-cover rounded-lg transition-transform duration-300 hover:scale-105'
                        }
                      />
                    </div>

                    {/* product info */}
                    <div className={'flex-grow flex flex-col justify-between'}>

                      <p className={'mt-2 text-sm font-serif font-semibold h-12 overflow-hidden'}>
                        {item.productName}
                      </p>

                      {/* default size price */}
                      <div className={'flex justify-between py-2'}>
                        <p className={'font-semibold'}>
                          &#8377; {defaultSizePrice}
                        </p>
                      </div>

                    </div>

                    {/* button */}
                    <Button
                      className={
                        'w-full text-sm h-8 rounded-lg border-none bg-primary-800 text-white font-semibold hover:shadow-[0_0_5px_#3D180F] active:scale-95 flex items-center justify-center mt-auto'
                      }
                    >
                      View more
                    </Button>

                  </Link>

                </div>

              </div>
            );
          })}

        </Slider>

      </div>

    </div>
  );
};

RelatedProducts.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      productName: PropTypes.string.isRequired,
      imageUrl: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
      ]),
      price: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      jewelryType: PropTypes.string.isRequired,
      size: PropTypes.arrayOf(
        PropTypes.shape({
          size: PropTypes.string,
          price: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
          ]),
          quantity: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
          ]),
        }),
      ),
    }),
  ).isRequired,

  currentProduct: PropTypes.shape({
    id: PropTypes.string.isRequired,
    jewelryType: PropTypes.string.isRequired,
  }).isRequired,
};

export default RelatedProducts;
